module.exports = __webpack_public_path__ + "static/photo1-008c37092344113e663da6db0fffef29.png";